import React from 'react';

const Header = (props) => {

    const { header, header2, header3 } = props;

    return (
        <div>
            {header &&
                <h1>{header}</h1>
            }
            {header2 &&
                <h2>{header2}</h2>
            }
            {header3 &&
                <h3>{header3}</h3>
            }
        </div>
    )
};

export default Header;
